import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const Actions = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-top: 0.5px solid ${colors.alto};

  @media (max-width: ${breakpoints.medium}) {
    position: sticky;
    bottom: 0;
    background: ${colors.white};
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 -15px;
  }
`;
export const StylelessButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 16px;
  border: none;
  background: none;
  :hover {
    cursor: pointer;
  }
  :focus {
    outline: none;
  }
  & svg {
    height: 1.6rem !important;
    margin-right: 0.5rem !important;
    stroke-width: 2.5px !important;
    vertical-align: bottom !important;
    width: 1.6rem !important;
  }
`;

export const PrivacyNotice = styled.div`
  font-size: 0.75rem;
  padding: 0 0.5rem 0.5rem 0.5rem;

  // the styling for the links is defined in here, since the child is a translated string which includes <a> tags
  a {
    color: ${colors.pacificBlue};
    text-decoration: none;
  }
`;
